import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { AvatarSmall, Heading, NamedLink } from '../../components';
import css from './ListingPage.module.css';

const ArtistCard = ({ author, authorDisplayName }) => {
  const { bio, publicData } = author?.attributes?.profile || {};
  const profileUrl = publicData?.profileUrl;

  return (
    <div className={css.flashArtistCard}>
      <Heading as="h2" rootClassName={css.flashArtistCardTitle}>
        <FormattedMessage id="ListingPage.flashAboutArtist" />
      </Heading>
      <div className={css.flashArtistRow}>
        <AvatarSmall user={author} />
        <div className={css.flashArtistInfo}>
          <span className={css.flashArtistName}>{authorDisplayName}</span>
          {profileUrl && <span className={css.flashArtistHandle}>{profileUrl}</span>}
        </div>
      </div>
      {bio && <p className={css.flashArtistBio}>{bio}</p>}
      {author?.id && (
        <NamedLink
          className={css.flashViewProfileBtn}
          name="ArtistProfileBasePage"
          params={{ id: author.id.uuid }}
        >
          <FormattedMessage id="ListingPage.flashViewProfile" />
        </NamedLink>
      )}
    </div>
  );
};

export default ArtistCard;
